import { render } from "./projectstab.vue?vue&type=template&id=18903842"
import script from "./projectstab.vue?vue&type=script&lang=js"
export * from "./projectstab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__